import * as constants from './constants';
import checkStatus from '../../../utils/checkStatus';
import { get } from '../../../utils/http';
import R from 'ramda';
import querystring from 'querystring';

const callApiPost = (url, body) => {
  return fetch(url, {
    method: 'post',
    body: JSON.stringify(body),
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
  })
    .then(checkStatus);
};
const callApiGet = url => {
  return fetch(url, {
    method: 'get',
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
  })
    .then(checkStatus);
};
export const clearStore = () => ({ type: constants.CLEAR_STORE });
export function updateProps(payload) {
  return { type: constants.UPDATE_PROPS, payload };
};

export const getContractRequest = payload => (dispatch, getState) => {
  dispatch(updateProps({ gettingRequests: true }));
  return get(`/proxy/contracting/requests?${querystring.stringify(R.merge(payload, {
    emails: JSON.stringify(payload.emails),
  }))}`)
  .then(checkStatus)
  .then(res => res.json())
  .then(res => dispatch({ type: 'GOT_MATCHED_REQUESTS_FOR_SUPPLIER_SENDING_RATES', payload: res }))
  .catch(err => {
    console.log(err);
    dispatch(updateProps({ gettingRequests: false }));
  });
};
export function processPartners(payload, startDate, endDate) {
  return dispatch => {
    dispatch(updateProps(payload));
    dispatch({ type: constants.PROCESSING_PARTNERS });
    return callApiPost('/proxy/contracting/processingPartners', { partners: payload.partnersToSendTo, startDate, endDate })
      .then(res => res.json())
      .then(({ processedPartners }) => dispatch({
        type: constants.PARTNERS_PROCESSED,
        payload: R.merge(payload || {}, { partnersToSendTo: processedPartners, processingPartners: false }) }))
      .catch(() => {
        dispatch({ type: constants.PROCESSING_PARTNERS });
        dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Processing Partners Failed' });
      });
  };
}

export function checkConnection(payload) {
  return { type: constants.CHECK_CONNECTION, payload };
}

export function getContractingPartners(startDate, endDate) {
  return dispatch => {
    return callApiGet(`/proxy/contracting/partners?startDate=${startDate}&endDate=${endDate}`)
      .then(res => res.json())
      .then(res => dispatch({ type: constants.GOT_CONTRACTING_PARTNERS, payload: res }));
  };
}
export function uncheckConnection(payload) {
  return { type: constants.UNCHECK_CONNECTION, payload };
}
import { loadPartners } from '../../actions';
export const loadExistingConnections = () => loadPartners(constants.LOADING_EXISTING_CONNECTIONS, constants.GOT_EXISTING_CONNECTIONS);



// WEBPACK FOOTER //
// ./src/app/stores/contracting/send-to-partners/actions.js